'use client';

import { useRouter } from 'next/navigation';
import { useFormStatus } from 'react-dom';

export function Form({
  action,
  children,
}: {
  action: (formData: FormData) => Promise<{ error?: string, success?: boolean } | undefined>;
  children: React.ReactNode;
}) {
  const router = useRouter();

  return (
    <form
      action={async (formData) => {
        const result = await action(formData);
        if (result?.success) {
          router.push('/');
        }
      }}
      className="flex flex-col gap-4 bg-white px-6 py-6 sm:px-12"
    >
      <div>
        <label
          htmlFor="email"
          className="block text-[11px] leading-[12px] text-black uppercase tracking-[0.33px]"
        >
          Email Address
        </label>
        <input
          id="email"
          name="email"
          type="email"
          placeholder="user@acme.com"
          autoComplete="email"
          required
          className="mt-1 w-full sb-field placeholder-black/50 bg-transparent"
        />
      </div>
      <div>
        <label
          htmlFor="password"
          className="block text-[11px] leading-[12px] text-black uppercase tracking-[0.33px]"
        >
          Password
        </label>
        <input
          id="password"
          name="password"
          type="password"
          required
          className="mt-1 w-full sb-field placeholder-black/50 bg-transparent"
        />
      </div>
      {children}
    </form>
  );
}
